import { RootState } from '@redux/types';
import { createSelector } from '@reduxjs/toolkit';

export const songDetailsRequestSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.songDetails,
  (songDetails) => ({
    error: undefined,
    value: undefined,
    ...songDetails,
  }),
);

export const backgroundRequestSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.background,
  (background) => background,
);

export const videoMetadataRequestSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.videoMetadata,
  (videoMetadata) => ({
    error: undefined,
    value: undefined,
    ...videoMetadata,
  }),
);

export const swipeColorsRequestSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.swipeColors,
  (swipeColors) => ({
    error: undefined,
    value: undefined,
    ...swipeColors,
  }),
);

export const lyricsRequestSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.lyrics,
  (lyrics) => ({
    error: undefined,
    value: undefined,
    ...lyrics,
  }),
);

export const instrumentalRequestSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.instrumental,
  (instrumental) => instrumental,
);

export const vocalGuideRequestSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.vocalGuide,
  (vocalGuide) => vocalGuide,
);

export const fadeDurationSelector = createSelector(
  (state: RootState) => state.videoPlayerResources.fadeDuration,
  (fadeDuration) => fadeDuration,
);
